export default "__VITE_ASSET__DJyzJDHp__"